module.exports = {"id":"dp2_5l3q1","text":"Digital Behaviour","instructions":"Online behaviour can influence how others perceive your digital reputation.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"PickOne","random":false,"options":[{"id":"dp2_5l3q1-a1","text":"True","score":3.7},{"id":"dp2_5l3q1-a2","text":"Not sure","score":1.3},{"id":"dp2_5l3q1-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l3q1.json
// module id = 1072
// module chunks = 41